import { store } from "..";

const isUserHaveRole = (role) => {
  const user = store.getState()?.user;
  console.log("ROLE", user?.roleId === role)
  return user?.roleId === role;
};

export default isUserHaveRole;
